const CALCTYPE = {
  data() {
    return {
      membershipTypeOptions: []
    }
  },
  methods: {
    calcType(index) {
      if (index === -1 && this.memberUpdate.hasOwnProperty('dateOfBirth')) {
        this.dateOfBirth = this.memberUpdate.dateOfBirth
        this.$nextTick(() => {
          // eslint-disable-next-line
          // console.log(this.$store.state.products)
          if (this.isUnder17 === false) {
            const tempProducts = this.$store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon').filter((product) => {
              const requirements = JSON.parse(product.requirements)
              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age <= 17 && requirements.max_age >= 17
                } else if (requirements.min_age) {
                  return requirements.min_age <= 17
                } else if (requirements.max_age) {
                  return requirements.max_age >= 17
                }
              }
              return false
            })
            this.membershipTypeOptions = [...tempProducts]
          } else if (this.isUnder8) {
            const tempProducts = this.$store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon').filter((product) => {
              const requirements = JSON.parse(product.requirements)
              if (requirements) {
                if (requirements.max_age) {
                  return requirements.max_age < 8
                }
              }
              return false
            })
            this.membershipTypeOptions = [...tempProducts]
          } else if (this.isUnder13) {
            const tempProducts = this.$store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon').filter((product) => {
              const requirements = JSON.parse(product.requirements)
              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age >= 8 && requirements.max_age <= 12
                }
              }
              return false
            })
            this.membershipTypeOptions = [...tempProducts]
          } else if (this.isUnder17) {
            const tempProducts = this.$store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon').filter((product) => {
              const requirements = JSON.parse(product.requirements)
              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age >= 13 && requirements.max_age <= 16
                }
              }
              return false
            })
            this.membershipTypeOptions = [...tempProducts]
          }
        })
      } else if (this.memberUpdate[index].hasOwnProperty('dateOfBirth')) {
        this.dateOfBirth = this.memberUpdate[index].dateOfBirth
        this.$nextTick(() => {
          // this.$refs.membershipType[index]
          // eslint-disable-next-line
          // console.log(this.$store.state.products)
          if (this.isUnder17 === false) {
            const tempProducts = this.$store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon').filter((product) => {
              const requirements = JSON.parse(product.requirements)
              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age <= 17 && requirements.max_age >= 17
                } else if (requirements.min_age) {
                  return requirements.min_age <= 17
                } else if (requirements.max_age) {
                  return requirements.max_age >= 17
                }
              }
              return false
            })
            this.membershipTypeOptions.splice(index, 1, tempProducts)
          } else if (this.isUnder8) {
            const tempProducts = this.$store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon').filter((product) => {
              const requirements = JSON.parse(product.requirements)
              if (requirements) {
                if (requirements.max_age) {
                  return requirements.max_age < 8
                }
              }
              return false
            })
            this.membershipTypeOptions.splice(index, 1, tempProducts)
          } else if (this.isUnder13) {
            const tempProducts = this.$store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon').filter((product) => {
              const requirements = JSON.parse(product.requirements)
              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age >= 8 && requirements.max_age <= 12
                }
              }
              return false
            })
            this.membershipTypeOptions.splice(index, 1, tempProducts)
          } else if (this.isUnder17) {
            const tempProducts = this.$store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon').filter((product) => {
              const requirements = JSON.parse(product.requirements)
              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age >= 13 && requirements.max_age <= 16
                }
              }
              return false
            })
            this.membershipTypeOptions.splice(index, 1, tempProducts)
          }
        })
      }
    }
  }
}

export default CALCTYPE



// WEBPACK FOOTER //
// ./src/mixins/calcType.js